import router from "@/router"

import { setAuthHeader, clearAuthHeader } from "@/services/api"
import * as localAuth from "./providers/localStorage"
import AuthAPI from "./providers/api"

const actions = {
  clearAuth: async ({ commit }) => {
    try {
      localAuth.deleteLocalAuthInfo()
      commit("clearAuth")
      router.replace("/signin")
    } catch (err) {
      console.warn("Error in auth/clearAuth action", err)
    }
  },
  login: async ({ commit }, { username, password, redirect }) => {
    commit("setLoggingIn", true)
    try {
      const res = await AuthAPI.login({ username, password })
      commit("setLoggingIn", false)
      const { data } = res
      setAuthHeader(data.accessToken)
      commit("setAuthInfo", data)
      localAuth.setLocalAuthInfo(data)
      if (redirect) {
        router.replace(redirect)
      } else {
        router.replace("/")
      }
    } catch (error) {
      // axios throws on 401's so handle it here
      if (error.response) {
        if (error.response.status === 401) {
          commit("setAuthError", "You've entered a bad username or password")
        } else {
          commit("setAuthError", "Error signing in. Try again later")
        }
      }
    }
  },
  logout: async ({ commit }) => {
    try {
      const res = await AuthAPI.logout()
      if (res.status === 200) {
        clearAuthHeader()
        commit("clearAuth")
        localAuth.deleteLocalAuthInfo()
        router.replace("/signin")
      } else {
        throw new Error("Error calling auth/logout")
      }
    } catch (err) {
      console.warn("Error in auth/logout", err)
      router.replace("/signin")
    }
  },
  updateLocalAccessToken: async (context, token) => {
    try {
      const auth = localAuth.fetchLocalAuthInfo()
      if (auth) {
        const newInfo = {
          ...auth,
          accessToken: token
        }
        localAuth.setLocalAuthInfo(newInfo)
      }
    } catch (err) {
      console.warn("Error in auth/updateLocalAccessToken action", err)
    }
  }
}

export default actions
